import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { gtmPageview, trackKeyPageView } from "@/lib/gtm";

/** High-intent pages worth their own retargeting audience. */
const KEY_PAGES: Record<string, string> = {
  "/": "Home",
  "/restrooms": "Restrooms",
  "/events": "Events",
  "/contact": "Contact",
  "/checkout": "Checkout",
};

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Defer so document.title (set by pages on mount) is current.
    const id = window.setTimeout(() => {
      gtmPageview(pathname + search);
      const keyPage = KEY_PAGES[pathname];
      if (keyPage) trackKeyPageView(keyPage);
      if (pathname === "/" && window.location.hash === "#pricing") {
        trackKeyPageView("Pricing");
      }
    }, 0);
    return () => window.clearTimeout(id);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
